module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-6-zoom.3c746fe3.png";